/* goose-games.de · Event-Kalender
   Liest die vom Section-Template gerenderten Daten und baut Kalender, Tagesliste
   und Buchung. Warenkorb über die Shopify AJAX-API (/cart/add.js).
   Keine Abhängigkeiten. */
(function(){
  var root = document.querySelector('[data-gge]');
  if(!root) return;

  var DATA;
  try { DATA = JSON.parse(root.querySelector('[data-gge-data]').textContent); }
  catch(e){ console.warn('[gge] Daten konnten nicht gelesen werden', e); return; }

  var WD = ['So','Mo','Di','Mi','Do','Fr','Sa'];
  var WD_LONG = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
  var MON = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
  var GAMES = DATA.games || {};
  var CFG = DATA.config || {};

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function hexA(hex, a){
    var h = String(hex || '#c69a43').replace('#','');
    if(h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    return 'rgba('+parseInt(h.slice(0,2),16)+','+parseInt(h.slice(2,4),16)+','+parseInt(h.slice(4,6),16)+','+a+')';
  }
  function pad(n){ return String(n).padStart(2,'0'); }
  function dkey(d){ return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate()); }

  // Termin aus Metafeld (ISO) oder Variantentitel ("15.08.2026 19:00") lesen
  function parseStart(s){
    if(!s) return null;
    var iso = String(s).trim().replace(' ','T');
    var d = new Date(iso);
    if(!isNaN(d)) return d;
    var m = String(s).match(/(\d{1,2})[.\/](\d{1,2})[.\/](\d{4})[^\d]*(\d{1,2})[:.](\d{2})?/);
    if(m) return new Date(+m[3], +m[2]-1, +m[1], +m[4], +(m[5]||0));
    return null;
  }

  var today = new Date(); today.setHours(0,0,0,0);

  var OCC = [];
  (DATA.events||[]).forEach(function(ev){
    (ev.variants||[]).forEach(function(v){
      var start = parseStart(v.start);
      if(!start) return;
      if(start < today) return; // vergangene Termine gar nicht erst aufnehmen
      OCC.push({ ev:ev, v:v, start:start, key:dkey(start),
        time: pad(start.getHours())+':'+pad(start.getMinutes()),
        free: Math.max(0, v.free|0), cap: Math.max(1, v.cap|0),
        sold: !v.available || (v.free|0) <= 0 });
    });
  });
  OCC.sort(function(a,b){ return a.start - b.start; });

  var first = OCC.find(function(o){ return o.start >= today; }) || OCC[0];
  var S = {
    game:'all',
    month: first ? first.start.getFullYear()+'-'+pad(first.start.getMonth()+1) : dkey(today).slice(0,7),
    day: first ? first.key : dkey(today),
    sid:null, vid:null, tag:'', done:false, busy:false, cart:0
  };

  function color(g){ return (GAMES[g] && GAMES[g].color) || '#c69a43'; }
  function gname(g){ return (GAMES[g] && GAMES[g].name) || g; }
  function list(){ return OCC.filter(function(o){ return S.game === 'all' || o.ev.game === S.game; }); }
  function seatText(o){ return o.sold ? 'Ausverkauft' : o.free + ' von ' + o.cap + ' Plätzen frei'; }
  function seatColor(o){ return o.sold ? '#e0413f' : (o.free <= 3 ? '#f0a53a' : '#8fb87a'); }
  function shortTitle(o){
    if(o.ev.series) return gname(o.ev.game);
    return String(o.ev.title).split(':')[0].replace(gname(o.ev.game)+' ','');
  }

  function renderFilters(){
    var box = root.querySelector('[data-gge-filters]');
    var items = [{id:'all', name: CFG.allLabel || 'Alle Spiele'}];
    Object.keys(GAMES).forEach(function(g){
      if(OCC.some(function(o){ return o.ev.game === g; })) items.push({id:g, name:GAMES[g].name});
    });
    box.innerHTML = items.map(function(it){
      var on = S.game === it.id, col = it.id === 'all' ? '#c69a43' : color(it.id);
      return '<button class="gge-chip" type="button" data-game="'+esc(it.id)+'" aria-pressed="'+on+'"'+
        ' style="'+(on ? 'background:'+col+';border-color:'+col+';color:#171310' : 'color:'+(it.id==='all'?'#c9b9a4':col))+'">'+
        (it.id === 'all' ? '' : '<i></i>')+'<span style="color:'+(on?'#171310':'#c9b9a4')+'">'+esc(it.name)+'</span></button>';
    }).join('');
  }

  function renderGrid(){
    var p = S.month.split('-'), y = +p[0], m = +p[1]-1;
    root.querySelector('[data-gge-month]').textContent = MON[m]+' '+y;
    var days = new Date(y, m+1, 0).getDate();
    var lead = (new Date(y, m, 1).getDay()+6) % 7;
    var L = list(), count = 0;
    var html = ['Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag','Sonntag']
      .map(function(w){ return '<div class="gge-wd">'+w+'</div>'; }).join('');
    for(var i=0;i<lead;i++) html += '<div class="gge-cell gge-cell--pad"></div>';
    for(var n=1;n<=days;n++){
      var k = y+'-'+pad(m+1)+'-'+pad(n);
      var ev = L.filter(function(o){ return o.key === k; });
      count += ev.length;
      var isToday = k === dkey(today), on = S.day === k;
      var lead2 = ev[0] ? color(ev[0].ev.game) : null;
      html += '<button class="gge-cell'+(ev.length?' gge-cell--has':'')+(isToday?' gge-cell--today':'')+
        '" type="button" data-day="'+k+'" aria-pressed="'+on+'"'+
        (ev.length && !on ? ' style="background:'+hexA(lead2,.05)+';border-color:'+hexA(lead2,.34)+'"' : '')+'>'+
        '<span class="gge-num"><span>'+n+'</span>'+(isToday?'<span class="gge-today">Heute</span>':'')+'</span>'+
        '<span class="gge-cell-evs">'+ ev.slice(0,3).map(function(o){
          var c = color(o.ev.game);
          return '<span class="gge-ev'+(o.sold?' gge-ev--out':'')+'" data-open="'+o.ev.id+'" data-v="'+o.v.id+'"'+
            ' style="background:'+hexA(c, o.sold?.1:.22)+';border-left-color:'+(o.sold?hexA(c,.45):c)+'">'+
            '<b>'+o.time+'</b><span>'+esc(shortTitle(o))+'</span></span>';
        }).join('') + '</span>'+
        (ev.length > 3 ? '<span class="gge-more">+'+(ev.length-3)+' weitere</span>' : '')+
      '</button>';
    }
    root.querySelector('[data-gge-grid]').innerHTML = html;
    root.querySelector('[data-gge-count]').textContent = count + (count === 1 ? ' Termin im Monat' : ' Termine im Monat');
  }

  function renderSide(){
    var d = new Date(S.day.slice(0,4), +S.day.slice(5,7)-1, +S.day.slice(8,10));
    root.querySelector('[data-gge-daytitle]').textContent =
      WD_LONG[d.getDay()]+', '+d.getDate()+'. '+MON[d.getMonth()];
    var ev = list().filter(function(o){ return o.key === S.day; });
    var box = root.querySelector('[data-gge-rows]');
    if(!ev.length){
      box.innerHTML = '<div class="gge-empty">'+esc(CFG.emptyDay || 'An diesem Tag ist nichts angesetzt. Tag im Kalender wählen.')+'</div>';
    } else {
      box.innerHTML = ev.map(function(o){
        var c = color(o.ev.game), on = S.sid === o.ev.id;
        return '<button class="gge-row'+(o.sold?' gge-row--out':'')+'" type="button" data-open="'+o.ev.id+'" data-v="'+o.v.id+'"'+
          ' style="background:'+hexA(c,.1)+';border-color:'+(on?c:hexA(c,.3))+'">'+
          '<s style="background:'+c+'"></s>'+
          '<span class="gge-row-head"><span class="gge-time">'+o.time+'</span>'+
          '<span class="gge-game" style="color:'+c+'">'+esc(gname(o.ev.game))+'</span></span>'+
          '<span class="gge-row-title">'+esc(o.ev.title)+'</span>'+
          '<span class="gge-row-foot"><span class="gge-seats" style="color:'+seatColor(o)+'">'+seatText(o)+'</span>'+
          '<span class="gge-price">'+esc(o.v.price)+'</span></span></button>';
      }).join('');
    }
    renderBooking();
  }

  function renderBooking(){
    var box = root.querySelector('[data-gge-book]');
    if(!S.sid){ box.innerHTML = ''; return; }
    var occ = OCC.filter(function(o){ return o.ev.id === S.sid; });
    if(!occ.length){ box.innerHTML = ''; return; }
    var cur = occ.filter(function(o){ return o.v.id === S.vid; })[0] || occ[0];
    var c = color(cur.ev.game);
    var needTag = !!cur.ev.requireTag;
    var tagOk = !needTag || S.tag.trim().length > 1;
    var can = !cur.sold && tagOk && !S.busy;
    var pct = Math.round(((cur.cap - cur.free) / cur.cap) * 100);
    var d = cur.start;

    box.innerHTML =
      '<div class="gge-book" style="border-top-color:'+c+'">'+
        '<div class="gge-book-head"><div>'+
          '<div class="gge-game" style="color:'+c+'">'+esc(gname(cur.ev.game))+'</div>'+
          '<h3>'+esc(cur.ev.title)+'</h3></div>'+
          '<button class="gge-close" type="button" data-close>✕</button></div>'+
        (cur.ev.note ? '<p class="gge-note">'+esc(cur.ev.note)+'</p>' : '')+
        '<div class="gge-label">Termin wählen</div>'+
        '<div class="gge-dates">'+ occ.map(function(o){
          var on = o.v.id === cur.v.id;
          return '<button class="gge-date'+(o.sold?' gge-date--out':'')+'" type="button" data-v="'+o.v.id+'"'+
            ' style="background:'+(on?c:hexA(c,.08))+';border-color:'+(on?c:hexA(c,.28))+';color:'+(on?'#171310':(o.sold?'#8a6b62':'#c9b9a4'))+'">'+
            '<u>'+WD[o.start.getDay()]+'</u><b>'+o.start.getDate()+'.'+(o.start.getMonth()+1)+'.</b>'+
            '<i>'+(o.sold ? 'voll' : o.free+' frei')+'</i></button>';
        }).join('') +'</div>'+
        '<div class="gge-when"><div><b>'+WD_LONG[d.getDay()]+', '+d.getDate()+'. '+MON[d.getMonth()]+' · '+cur.time+' Uhr</b>'+
          '<span>'+esc(CFG.venue || 'Einlass 30 Min vorher · Wiesbaden')+'</span></div>'+
          '<em>'+esc(cur.v.price)+'</em></div>'+
        '<div class="gge-barrow"><span class="gge-seats" style="color:'+seatColor(cur)+'">'+seatText(cur)+'</span>'+
          '<span class="gge-cap">'+cur.cap+' Plätze gesamt</span></div>'+
        '<div class="gge-bar"><i style="width:'+pct+'%;background:'+(cur.sold?'#e0413f':c)+'"></i></div>'+
        (needTag ? '<div class="gge-label">'+esc(CFG.tagLabel || 'Gamer-Tag · Pflichtfeld')+'</div>'+
          '<input class="gge-input'+(S.tag.length>0 && !tagOk ? ' gge-input--err':'')+'" data-tag type="text" value="'+esc(S.tag)+
          '" placeholder="'+esc(CFG.tagPlaceholder || 'z. B. LuffyD#1234')+'">'+
          '<div class="gge-hint">'+esc(CFG.tagHint || 'Wird für die Turnier-Software gebraucht. Steht später auf dem Ticket.')+'</div>' : '')+
        '<button class="gge-buy" type="button" data-buy '+(can?'':'disabled')+'>'+
          (cur.sold ? 'Ausverkauft' : (S.busy ? 'Moment …' : (S.done ? 'Noch einen Platz hinzufügen' :
            (needTag && !tagOk ? 'Gamer-Tag eintragen' : 'Für '+esc(cur.v.price)+' in den Warenkorb'))))+'</button>'+
        (cur.sold && CFG.waitlistUrl ? '<a class="gge-wait" style="display:flex;align-items:center;justify-content:center;text-decoration:none" href="'+esc(CFG.waitlistUrl)+'">Auf die Warteliste</a>' : '')+
        (S.done ? '<div class="gge-done"><b>✓ Im Warenkorb</b><a href="/cart">Zur Kasse →</a></div>' : '')+
      '</div>';
  }

  function renderCart(){
    var el = root.querySelector('[data-gge-cart]');
    el.setAttribute('data-full', S.cart > 0 ? '1' : '0');
    el.querySelector('span').textContent = S.cart;
  }

  function render(){ renderFilters(); renderGrid(); renderSide(); renderCart(); }

  root.addEventListener('click', function(e){
    var t = e.target.closest('[data-game],[data-day],[data-open],[data-v],[data-close],[data-buy],[data-nav]');
    if(!t || !root.contains(t)) return;

    if(t.hasAttribute('data-nav')){
      var p = S.month.split('-'), y = +p[0], m = +p[1]-1 + (t.getAttribute('data-nav') === 'next' ? 1 : -1);
      if(m < 0){ m = 11; y--; } if(m > 11){ m = 0; y++; }
      S.month = y+'-'+pad(m+1); renderGrid(); return;
    }
    if(t.hasAttribute('data-game')){ S.game = t.getAttribute('data-game'); render(); return; }
    if(t.hasAttribute('data-close')){ S.sid = null; S.vid = null; S.done = false; renderSide(); return; }
    if(t.hasAttribute('data-buy')){ addToCart(); return; }

    // Termin-Chip im Kalender oder Zeile in der Tagesliste
    if(t.hasAttribute('data-open')){
      var o = OCC.filter(function(x){ return String(x.v.id) === t.getAttribute('data-v'); })[0];
      S.sid = +t.getAttribute('data-open'); S.vid = o ? o.v.id : null;
      S.done = false; if(o) S.day = o.key;
      renderGrid(); renderSide();
      if(window.matchMedia('(max-width:899px)').matches){
        var b = root.querySelector('[data-gge-book]');
        if(b) window.scrollTo({ top: b.getBoundingClientRect().top + window.pageYOffset - 20, behavior:'smooth' });
      }
      return;
    }
    if(t.hasAttribute('data-day')){ S.day = t.getAttribute('data-day'); S.sid = null; S.done = false; renderGrid(); renderSide(); return; }
    if(t.hasAttribute('data-v')){ S.vid = +t.getAttribute('data-v'); S.done = false; renderBooking(); return; }
  });

  root.addEventListener('input', function(e){
    if(e.target.hasAttribute('data-tag')){
      S.tag = e.target.value;
      var buy = root.querySelector('[data-buy]');
      var occ = OCC.filter(function(o){ return o.v.id === S.vid; })[0];
      if(buy && occ){
        var ok = S.tag.trim().length > 1 && !occ.sold;
        buy.disabled = !ok;
        buy.textContent = ok ? 'Für '+occ.v.price+' in den Warenkorb' : 'Gamer-Tag eintragen';
      }
    }
  });

  function addToCart(){
    var occ = OCC.filter(function(o){ return o.v.id === S.vid; })[0];
    if(!occ || occ.sold || S.busy) return;
    if(CFG.demo){
      S.busy = false; S.done = true; S.cart++; S.tag = '';
      renderBooking(); renderCart(); return;
    }
    var props = {};
    if(occ.ev.requireTag) props[CFG.tagProperty || 'Gamer-Tag'] = S.tag.trim();
    props[CFG.dateProperty || 'Termin'] = occ.start.toLocaleString('de-DE',
      { weekday:'short', day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' });
    S.busy = true; renderBooking();
    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'}, credentials:'same-origin',
      body: JSON.stringify({ items:[{ id: occ.v.id, quantity:1, properties: props }] })
    })
    .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
    .then(function(){ return fetch('/cart.js', {credentials:'same-origin'}).then(function(r){ return r.json(); }); })
    .then(function(cart){
      S.cart = cart.item_count; S.busy = false; S.done = true; S.tag = '';
      document.dispatchEvent(new CustomEvent('gge:added', { detail:{ variant: occ.v.id } }));
      renderBooking(); renderCart();
    })
    .catch(function(err){
      S.busy = false; renderBooking();
      alert((err && err.description) || 'Der Platz konnte nicht in den Warenkorb gelegt werden. Bitte Seite neu laden.');
    });
  }

  if(!CFG.demo){
    fetch('/cart.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(c){ S.cart = c.item_count; renderCart(); })
      .catch(function(){});
  }

  render();
})();